import React from 'react'
import { connect } from 'react-redux'
import { Nav } from 'react-bootstrap'
import { updateAccount } from '../../../actions/updateActions'
import PropTypes from 'prop-types'
import { msalAppRS, msalAppMX } from '../../../utils/authConfig'
import IdleTimer from 'react-idle-timer'
import globals from 'application/constants/globals'

class ConsultantLogoutButton extends React.Component {
  constructor(props) {
    super(props)
    this.idleTimer = null
    this.IDLE_TIME_OUT = 1000 * 60 * 30 //30min
    this.handleOnIdle = this.handleOnIdle.bind(this)
  }

  handleOnIdle(event) {
    this.handleSignOut()
  }
  handleSignOut = (e) => {
    let msal = globals.isBrandMX ? msalAppMX : msalAppRS
    e && e.preventDefault()
    window.localStorage.clear()
    msal.logout()

    this.props.updateAccount(null)
    this.props.dispatch(updateAccount(null))

    if (this.props.opportunity && this.props.opportunity.opportunityId) {
      window.location.href =
        '/consultant/login?oppId=' + this.props.opportunity.opportunityId
    } else {
      window.location.href = '/consultant/login'
    }
  }

  render() {
    return (
      <>
        <IdleTimer
          ref={(ref) => {
            this.idleTimer = ref
          }}
          timeout={this.IDLE_TIME_OUT}
          onIdle={this.handleOnIdle}
          debounce={250}
        />
        <Nav.Link onClick={this.handleSignOut}>Logout</Nav.Link>
      </>
    )
  }
}

ConsultantLogoutButton.propTypes = {
  account: PropTypes.object,
  error: PropTypes.string,
}

function mapStateToProps() {
  return {
    opportunity: StaticRange.opportunity,
  }
}

export default connect(mapStateToProps)(ConsultantLogoutButton)
